import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import {
  Grid,
  Card,
  CardHeader,
  CardContent,
  Typography,
  Button,
  Box,
  ToggleButtonGroup,
  ToggleButton,
} from "@mui/material";
import {
  Reports,
  resetFilters,
  setFilters,
} from "../../../app/slices/reportsSlice";
import { SelectStore } from "../../../components/Selects/SelectStore";
import { SelectEmployee } from "../../../components/Selects/SelectEmployee";
import { SelectAts } from "../../../components/Selects/SelectAts";
import { SelectCabinet } from "../../../components/Selects/SelectCabinet";

const StoreItemsMovementFilters = () => {
  const dispatch = useDispatch();
  const {
    filters: { storeMovementReport },
  } = useSelector((state) => state.reports);

  useEffect(() => {
    return () => dispatch(resetFilters({ type: "storeMovementReport" }));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleFetchReport = () => {
    // Extract just the ID before sending to API
    const params = {
      ...storeMovementReport,
      location_id: storeMovementReport.location_id?.id || null
    };
    
    dispatch(Reports.fetch("storeMovementReport", params));
  };

  return (
    <Card>
      <CardHeader
        title={
          <Typography variant="h6" component="div">
            Store Items Movement
          </Typography>
        }
      />
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box display="flex" flexDirection="column" mb={2}>
              <Typography variant="subtitle1">Location Type</Typography>
              <ToggleButtonGroup
                color="primary"
                size="small"
                value={storeMovementReport.location_type}
                exclusive
                onChange={(e, value) => {
                  dispatch(
                    setFilters({
                      type: "storeMovementReport",
                      data: { location_type: value, location_id: null },
                    })
                  );
                }}
              >
                <ToggleButton value="Store">Store</ToggleButton>
                <ToggleButton value="User">User</ToggleButton>
                <ToggleButton value="ATS">ATS</ToggleButton>
                <ToggleButton value="Cabinet">Cabinet</ToggleButton>
              </ToggleButtonGroup>
            </Box>
          </Grid>
          
          {storeMovementReport.location_type === "Store" && (
            <Grid item xs={4}>
              <SelectStore
                fullWidth
                value={storeMovementReport.location_id}
                onChange={(e, value) => {
                  dispatch(
                    setFilters({
                      type: "storeMovementReport",
                      data: { location_id: value },
                    })
                  );
                }}
              />
            </Grid>
          )}
          
          {storeMovementReport.location_type === "User" && (
            <Grid item xs={4}>
              <SelectEmployee
                fullWidth
                value={storeMovementReport.location_id}
                onChange={(e, value) => {
                  dispatch(
                    setFilters({
                      type: "storeMovementReport",
                      data: { location_id: value },
                    })
                  );
                }}
              />
            </Grid>
          )}
          
          {storeMovementReport.location_type === "ATS" && (
            <Grid item xs={4}>
              <SelectAts
                fullWidth
                value={storeMovementReport.location_id}
                onChange={(e, value) => {
                  dispatch(
                    setFilters({
                      type: "storeMovementReport",
                      data: { location_id: value },
                    })
                  );
                }}
              />
            </Grid>
          )}
          
          {storeMovementReport.location_type === "Cabinet" && (
            <Grid item xs={4}>
              <SelectCabinet
                fullWidth
                value={storeMovementReport.location_id}
                onChange={(e, value) => {
                  dispatch(
                    setFilters({
                      type: "storeMovementReport",
                      data: { location_id: value },
                    })
                  );
                }}
              />
            </Grid>
          )}
          
          <Grid item xs={3}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleFetchReport}
              sx={{
                textTransform: "capitalize",
              }}
              disabled={!storeMovementReport.location_id || !storeMovementReport.location_type}
            >
              Show results
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default StoreItemsMovementFilters; 